import type { AppThunk } from 'state';
import { PackageCacheFlightRoutesService } from 'common/packageCache';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import handleRequestError from 'managers/handleRequestError';
import { setFetching, setAirports } from '../slice';

function fetchAirports(): AppThunk {
  return async function fetchAirportsThunk(dispatch, getState) {
    try {
      const { fetching } = getState().packageCache.flightRoutes.airports;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));

      const data = await PackageCacheFlightRoutesService.getFlightRoutesAirports();

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setAirports(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on fetch flight routes airports!', setFetching));
    }
  };
}

export default fetchAirports;
